import type {CreateTemplateParams} from 'notebook/entry-templates/collections/TemplateCollectionDAO';
import type {TemplateCollection, TemplateCollectionSummary} from 'notebook/entry-templates/TemplateConstants';

export const TEMPLATE_COLLECTION_EVENT_PAYLOADS = {
  TEMPLATE_COLLECTIONS_FETCH: {} as {},
  TEMPLATE_COLLECTIONS_FETCH_COMPLETED: {} as {
    collections: Array<TemplateCollectionSummary>;
  },
  TEMPLATE_COLLECTIONS_FETCH_FAILED: {} as {},

  TEMPLATE_COLLECTION_FETCH: {} as {
    collectionId: string;
  },
  TEMPLATE_COLLECTION_FETCH_COMPLETED: {} as {
    collection: TemplateCollection;
  },
  TEMPLATE_COLLECTION_FETCH_FAILED: {} as {},

  TEMPLATE_COLLECTION_UPDATE: {} as {
    collectionId: string;
    data: CreateTemplateParams;
  },
  TEMPLATE_COLLECTION_UPDATE_COMPLETED: {} as {
    collectionId: string;
    collection: Partial<TemplateCollection>;
  },
  TEMPLATE_COLLECTION_UPDATE_FAILED: {} as {},

  TEMPLATE_COLLECTION_DELETE: {} as {
    templateCollectionId: string;
  },
  TEMPLATE_COLLECTION_DELETE_COMPLETED: {} as {
    collectionId: string;
  },
  TEMPLATE_COLLECTION_DELETE_FAILED: {} as {},
} as const;

export type TemplateCollectionEventPayload = typeof TEMPLATE_COLLECTION_EVENT_PAYLOADS;
